<template>
    <div class="pb-2">
      <div class="bg-theme-green border-0 rounded-t-xl px-4 py-4 text-white">
         <div class="flex justify-between items-center">
             <h2 class="font-semibold leading-tight truncate text-[20px] mt-0">Create New</h2>
             <div class="flex flex-col">
                 <div class="flex justify-end items-center">
                     <button @click.prevent="addPricingGroup()" class="cursor-pointer rounded-md bg-white text-theme-green py-2 px-4 hover:bg-theme-darkgreen hover:text-white mr-3">
                        SAVE
                     </button>
                     <span @click.prevent="clearComponent" class="cursor-pointer rounded-md  text-white py-2 pl-1  hover:opacity-70">CLOSE</span>
                     <!-- <mdicon @click.prevent="clearComponent" size="32" name="close" class="cursor-pointer text-lg hover:opacity-60"/> -->
                 </div>
             </div>
         </div>
      </div>
   
   
      <div class="bg-[#2B2C32] px-[16px] py-[24px] rounded-lg">
        <div class="text-[16px] font-[700]">Select Locations</div>
        <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
            <div class="w-full xl:w-1/2">
               <div :class="'input-wrapper ' + (form.name.error_type)">
                   <label class="text-xs mb-1">Name</label>
                   <input v-model="form.name.value" @keyup="validateFields(['name'])" placeholder="Be creative" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-[16px] text-theme-white py-[8px] focus:ring-0" type="text">
                   <p class="field-error label-text mt-1" v-if="form.name.error_message" v-text="form.name.error_message"></p>
               </div>
             </div>
   
             <div class="xl:w-1/2 w-full">
              <div :class="'input-wrapper relative ' + (form.locationIds.error_type)">
                <label class="mb-0 text-xs">Locations</label>
                <SelectLocations
                  class="bg-gray-black rounded relative"
                  @changed="validateFields(['locationIds'])"
                  v-model="form.locationIds.value"
                  :options="filteredLocationWithPricing"
                  :enabledOptions="vg_locations"
                  placeholder="Select"
                />
                <p class="field-error label-text mt-1" v-if="form.locationIds.error_message" v-text="form.locationIds.error_message"></p>
              </div>
            </div>
        </div>
   
        <div class="bg-theme-borderblack h-1 w-full my-4"></div>
        <div class="flex gap-[8px] flex-col items-start mb-3">
            <div class="text-[16px] font-[700]">Set Price</div>
            <div class="text-[16px] font-[400]">The location you select here will be used to update the price and markup settings at all other locations in the pricing group.</div>
            <div class="w-full">
                 <div :class="'input-wrapper relative ' + (form.primaryLocation.error_type)">
                     <label class="text-[12px] font-[400] mb-1">Primary Pricing Location</label>
                     <SelectLocation
                        class="bg-gray-black rounded relative"
                        classValue="top-10"
                        @changed="validateFields(['primaryLocation'])"
                        v-model="form.primaryLocation.value"
                        :options="vg_locations"
                        placeholder="Select One"
                        />
                    <p class="field-error label-text mt-1" v-if="form.primaryLocation.error_message" v-text="form.primaryLocation.error_message"></p>
                    <p class="label-text mt-1" v-else>&nbsp;</p>
                 </div>
             </div>
        </div>
      </div>


    </div>
   </template>

<script>
import {defineComponent, ref} from "vue"
import { useSnackbar } from "vue3-snackbar";
import { mapGetters, mapActions, mapMutations } from "vuex";
import PricingGroupApi from "@/controllers/PricingGroup";
import Helpers from '@/helpers';
import SelectLocations from './SelectLocations'
import SelectLocation from './SelectLocation'

  export default defineComponent({
  components: {
    SelectLocations,
    SelectLocation
  },
  props: {
    clearComponent: {
      type: Function,
      required: true,
    },
  },

  setup() {
    const snackbar = useSnackbar();
    const locationWithPricing = ref([]);
    const filteredLocationWithPricing = ref([])
    const form = ref({
      name: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required', 'min:3', 'max:30'],
      },
      locationIds: {
        value: [],
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      primaryLocation: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required'],
      }
    })

    return {
      locationWithPricing,
      filteredLocationWithPricing,
      snackbar,
      form,
    };
  },

  computed: {
    ...mapGetters({
      vg_locations: 'location/list',
      vg_activeBusiness: 'auth/activeBusiness',
      vg_selectedLocation: 'location/selected'
    }),
  },
  watch: {
    
  },

  async mounted() {
    this.getLocations()
  },
 
  methods: {
    async getLocations(){
        let res = await PricingGroupApi.locationList('includeBrandProfile=1');
        if(res.data.payload){
          this.locationWithPricing = res.data.payload
          this.filteredLocationWithPricing = [...this.locationWithPricing]
        }
    },
    /**
     * Validation captures
     */
    async validateFields(fields) {
      let res = await Helpers.validateFormFields(this.form, fields);
      // capture the fields
      this.form = res.data;
      if(res.error==false && fields.includes('primaryLocation')){
        // remove base location from locations if already selected
        this.form['locationIds'].value = this.form['locationIds'].value.filter(each => each != this.form['primaryLocation'].value)
        this.filteredLocationWithPricing = this.locationWithPricing.filter(each => each.id != this.form['primaryLocation'].value)
      }
      return res.error ? false : true;
    },
 
    async addPricingGroup() {
      // validate business field
      let validate = await this.validateFields(['name', 'primaryLocation', 'locationIds']);
      if(!validate) {
        return ;
      }

      // this.form.businessId = this.vg_activeBusiness.id;
      let data = Helpers.getFormKeyValue(this.form);
      let formatData = {
        pricingGroup: {
            name: data.name,
            basePriceLocationId: data.primaryLocation
        },
        locationIds: data.locationIds
      }
      this.va_spinner(true);
      let res = await PricingGroupApi.createPricingGroup(formatData);
      this.va_spinner(false);
      this.snackbar.add({
        type: 'info',
        text: res.status == 201 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
        duration: 7000,
      })
      if(res.status == 201) {
        this.clearComponent()
         this.emitter.emit("refresh-pricing-group-list", true);
      }
    },

    /**
     * Do not allow to add +,-,e
     */
    preventNonNumbers(e) {
       var ASCIICode = (e.which) ? e.which : e.keyCode
      if(ASCIICode == 43 || ASCIICode == 45 || ASCIICode == 101){
        return false;
      }
      return true;
    },
    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })
  },
});

</script>